import React from "react";
import styled from "styled-components";
import { style } from "./style";

const DropdownArrowWrapper = styled.div`
  position: absolute;
  top: 0;
`;

const Arrow = styled.div`
  position: absolute;
  margin-left: -7px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid white;
  top: -7px;
  z-index: ${style.vars.zIndex.raised};
`;

const ArrowBorder = styled.div`
  position: absolute;
  margin-left: -9px;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid ${style.colors.shadesOfGrey["4"]};
  top: -9px;
`;

type Props = {
  className?: string;
};

export const DropdownArrow: React.FC<Props> = (props) => {
  return (
    <DropdownArrowWrapper className={props.className}>
      <Arrow />
      <ArrowBorder />
    </DropdownArrowWrapper>
  );
};
